import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import 'rxjs/add/operator/map';
import { Observable, BehaviorSubject } from 'rxjs/Rx';

@Injectable()
export class AuthService {

	authState = new BehaviorSubject<boolean>(false);

	constructor(public http: HttpClient) {
		const localToken = sessionStorage.getItem('access_token_nv_admin');
		this.authState.next(!!localToken);
	}

	setup(token: any) {
		sessionStorage.setItem('access_token_nv_admin', token);
		this.authState.next(true);
	}

	signOut(): void {
		sessionStorage.clear();
		this.authState.next(false);
	}

	hasLoggedIn(): any {
		return !!(sessionStorage.getItem("access_token_nv_admin"));
	}

}



// WEBPACK FOOTER //
// ./src/app/services/auth/auth.service.ts